<template>
    <div>
        <no-ssl v-if="subscriptions.length == 0" />

        <ssl-item
            v-for="(subscription, index) of subscriptions"
            :domain="domain"
            :key="index"
            :subscription="subscription"
        />
    </div>
</template>

<script>
import SslItem from './SslItem.vue';
import NoSsl from './NoSsl.vue';

export default {
    components: {
        SslItem,
        NoSsl
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        subscriptions: {
            type: Array,
            default: () => []
        }
    }
};
</script>
